<template>
<ul class="uix-list">
  <li class="header">
    <h2>{{ header }}</h2></li>
  <li v-for="item in items"><a @click.prevent="$router.push({name: item.route})">{{ item.text }}</a></li>
</ul>
</template>
<script>
export default {
  props: {
    header: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: []
    }
  }
}
</script>


// WEBPACK FOOTER //
// SimpleMenu.vue?18f13476